import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { getRoleMasterList } from "../../redux/actions/mastersAction";
import RoleMasterContent from "../../components/Masters/RoleMaster/RoleMasterContent";

const RoleMaster = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRoleMasterList());
  }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <RoleMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default RoleMaster;
